"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContent = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ModalContent_styles_1 = require("./ModalContent.styles");
exports.ModalContent = function (_a) {
    var children = _a.children;
    var classes = ModalContent_styles_1.useModalContentStyles();
    return (React.createElement("div", { "data-signa": "modal-container", className: classes.main }, children));
};
